import React from "react";

export default function AdminDashboardContent() {

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center px-4 sm:px-6 md:px-8">
      <div className="w-full max-w-4xl bg-white px-6 sm:px-8 py-8 sm:py-10 rounded-lg shadow-md">
        <h1 className="text-2xl sm:text-3xl md:text-4xl text-center text-blue-900 font-bold mb-4 sm:mb-6">
          New Haven Native American Church
        </h1>
        <h2 className="text-2xl sm:text-3xl md:text-4xl text-center text-blue-900 font-bold mb-6">
          Back Office Educational Portal</h2>
        {/* <p className="text-2xl font-bold mb-6">Back Office Educational Portal</p> */}
        <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed">
          Welcome to your back office. To further your advancement and education, please enroll and complete the educational courses. These courses are to assist you on your Spiritual Journey and give you a greater understanding of the Church. Over time the courses will branch out into many different educational areas. Follow your unique educational path by choosing the courses you are most interested in. If you desire more education in a specific area, please email admin so they can better assist you on your Journey.
        </p>
      </div>
    </div>
  );
}
